<div class="data-analytics-header">
    <div class="header-left">
      <div class="header-text">
        <span *ngIf="insightLevel === 'factory'">{{ factoryName }} - Factory</span>
        <span *ngIf="insightLevel === 'line'">{{ lineName }} - Line</span>
        <span> Insights -</span>
        <span *ngIf="filterApplied">{{ getFormattedDate() }}</span>
  
        <div class="header-sub-text">
          <span *ngIf="insightLevel === 'line'" (click)="onClickLine()" (keydown.enter)="onClickLine()" (keydown.space)="onClickLine()" style="cursor: pointer;">
            {{ factorySummary.factoryName }}
          </span>
        </div>
      </div>
  
      <div class="da-bookmark" (click)="openSaveTag()" (keydown.enter)="openSaveTag()" (keydown.space)="openSaveTag()" matTooltip="Save" matTooltipPosition="above">
        <img *ngIf="!isCurrentURLSaved" src="assets/images/da-bookmark.svg" alt="">
        <img *ngIf="isCurrentURLSaved" src="assets/images/da-selected-bookmark.svg" alt="">
      </div>
  
      <div class="da-chat" (click)="toggleCommentBox()" (keydown.enter)="toggleCommentBox()" (keydown.space)="toggleCommentBox()" matTooltip="Comments" matTooltipPosition="above">
        <img src="assets/images/comments/comment-icon{{ showCommentBox ? '-active' : '' }}.svg" alt="">
      </div>
    </div>
  
    <div class="header-right">
      <div class="time-period-selector" (click)="showTimePickerStatus = true" (keydown.enter)="showTimePickerStatus = true" (keydown.space)="showTimePickerStatus = true" matRipple>
        <span *ngIf="filterApplied">{{ getFormattedDate() }}</span>
        <div class="calender-icon"></div>
      </div>
  
      <div class="time-picker-container" [ngClass]="{ 'showTimeContainer': showTimePickerStatus }">
        <app-dashboard-date-filter [disabledSelection]="['shift']" [initialValues]="emitDataList" (filterValues)="appliedFiltersList($event)">
        </app-dashboard-date-filter>
        <div class="button-container">
          <button mat-button class="cancel-btn" type="button" (click)="showHideTimeStatus('cancel')">
            {{ 'common.cancel' | translate }}
          </button>
          <button mat-button class="cancel-btn" type="button" [disabled]="!enableApplyBtn" (click)="showHideTimeStatus('ok')">
            {{ 'common.ok' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
  
  <div class="overlay-time fw fh" (click)="showTimePickerStatus = false" (keydown.enter)="showTimePickerStatus = false" (keydown.space)="showTimePickerStatus = false" *ngIf="showTimePickerStatus" [ngClass]="{ 'show': showTimePickerStatus }">
  </div>
  